<template>
  <div class="info">
    <div class="caption" v-html="info"></div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      info: null
    }
  },
  mounted(){
    axios.get('/info.html').then(response => (this.info = response.data));
  }
}
</script>
